import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import objectAssignPolyfill from 'es6-object-assign/auto'

import Vue from 'vue'
import App from './App'
import router from './router'

import Vue2TouchEvents from 'vue2-touch-events'
import Lang from 'vue-lang'
// import vueVimeoPlayer from 'vue-vimeo-player'
import VueYoutube from 'vue-youtube'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueScrollTo from 'vue-scrollto'

/** Custom code **/
import pUtil from './plugins/vue-util'

/** Language files **/
import langSv from './assets/text/sv.json'

const locales = {
  'sv': langSv
}

Vue.prototype.$bus = new Vue()
Vue.config.productionTip = false

Vue.use(objectAssignPolyfill)
Vue.use(pUtil)
Vue.use(Lang, {lang: 'sv', locales: locales})
Vue.use(VueAxios, axios)
// Vue.use(vueVimeoPlayer)
Vue.use(VueYoutube)
Vue.use(Vue2TouchEvents, {
  touchClass: 'touched'
})
Vue.use(VueScrollTo)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data () {
    return {
      shared: {
        currentPage: 'Home'
      }
    }
  },
  router,
  mounted () {
    this.util.init()
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js